module.exports = __webpack_public_path__ + "img/1536987809.f1b7cb77.jpg";